<template>
    <div id="app">
        <b-overlay v-bind:show="!gotdetails" rounded="sm">
            <template v-slot:overlay>
                <div class="text-center">
                    <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                    <p id="cancel-label">Please wait...</p>
                    <b-button
            ref="retry"
            variant="outline-danger"
            size="sm"
            aria-describedby="cancel-label"
            @click="init"
          >
            Retry
          </b-button>
                </div>
            </template>
        <Title>Home</Title>
        <Header />
        <div>
            <b-container class="main-container">
                <router-view></router-view>
            </b-container>
        </div>
        </b-overlay>
        <button @click="handleClickGetAuth" :disabled="!isInit">get auth code</button>
    <button @click="handleClickSignIn" v-if="!isSignIn" :disabled="!isInit">signIn</button>
    <button @click="handleClickSignOut" v-if="isSignIn" :disabled="!isInit">signOout</button>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'

    import Header from "./components/Header.vue";
    import Title from "./components/Title.vue";

    export default {

        name: "App",

        components: {
            Header,
            Title,
        },

        computed: {
            ...mapGetters([
                'gotdetails'
            ]),
        },

        data () {
            return {
                isInit: false,
                isSignIn: false
            }
        },

        methods: {
            ...mapActions(['init']),
            handleClickGetAuth(){
                this.$gAuth.getAuthCode()
                    .then(authCode => {
                        // On success
                        return this.$http.post('http://your-backend-server.com/auth/google', { code: authCode, redirect_uri: 'postmessage' })
                    })
                    .then(response => {
            // And then
            console.log(response)
        })
        .catch(error => {
            // On fail do something
            console.log(error)
        })
        },

            handleClickSignIn(){
            this.$gAuth.signIn()
            .then(user => {
                // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
                console.log('user', user)
                this.isSignIn = this.$gAuth.isAuthorized
                console.log(user)
            })
            .catch(error  => {
                // On fail do something
                console.log(error)
            })
            },

            handleClickSignOut(){
            this.$gAuth.signOut()
            .then(() => {
                // On success do something
                this.isSignIn = this.$gAuth.isAuthorized
            })
            .catch(error  => {
                // On fail do something
                console.log(error)
            })
            }
        },

        created: function () {
            this.init()
        },

        mounted () {
            let that = this
            let checkGauthLoad = setInterval(function(){
                that.isInit = that.$gAuth.isInit
                that.isSignIn = that.$gAuth.isAuthorized
                if(that.isInit) clearInterval(checkGauthLoad)
            }, 1000);
        }

    };
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .main-container {
        margin-top: 10px;
    }
</style>